import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Select, Input } from '../../Components/Form/Form'
import ReactPlaceholder from 'react-placeholder'
import Button from 'react-bootstrap/esm/Button';

const Kardex = _ => {
    const [ready, setReady] = useState(false)
    const [loading, setLoading] = useState(false)
    const [branchOfficeSelected, setBranchOfficeSelected] = useState('')
    const [branchOffice, serBranchOffice] = useState([])
    const [products, setProducts] = useState([])
    const [productSelected, setProductSelected] = useState('')
    const [reporte, setReport] = useState({})
    const [data, setData] = useState({
        p_date_start: '',
        p_date_end: ''
    })

    useEffect(() => {
        Controllers.branch_office.get_branch_office().then(res => {
            serBranchOffice(res.data)
            setReady(true)
        })
    }, [])

    const handleSubmit = _ => {
        if (!branchOfficeSelected || !productSelected) {
            Helpers.toast.construct({ response: 'warning', message: 'Completar campos para generar reporte', toast })
            return
        }

        setLoading(true)
        setReport({})

        Controllers.document.kardex_branch_office_product({
            p_id_branch_office: branchOfficeSelected,
            p_id_product: productSelected,
            p_date_start: data.p_date_start,
            p_date_end: data.p_date_end
        }).then(res => {
            setReport({
                excel: res.data.excel.file,
                filename: res.data.filename,
            })
            setLoading(false)
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => setLoading(false))
    }

    return <div className="ui-page">
        <div className="ui-page-head">
            <div>
                <h1 className="ui-page-title">Kardex</h1>
                <p className="ui-page-meta">Movimientos por sucursal y producto</p>
            </div>
        </div>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card className="ui-list-shell border-0">
                <Card.Header>
                    <span>Parámetros</span>
                </Card.Header>
                <Card.Body>
                    <div className="ui-report-filters">
                    <FormCustom loadSubmit={loading} textButton="Generar Reporte" onSubmit={handleSubmit}>
                        <Input
                            classNameParent="col-6 mb-3"
                            type="date"
                            icon="far fa-calendar-alt"
                            placeholder="Fecha Inicio"
                            text="Fecha Inicio"
                            required
                            value={data.p_date_start}
                            onChange={e => {
                                setReport({})
                                setData({ ...data, p_date_start: e.currentTarget.value })
                            }}
                        />
                        <Input
                            classNameParent="col-6 mb-3"
                            type="date"
                            icon="far fa-calendar-alt"
                            placeholder="Fecha Fin"
                            text="Fecha Fin"
                            required
                            value={data.p_date_end}
                            onChange={e => {
                                setReport({})
                                setData({ ...data, p_date_end: e.currentTarget.value })
                            }}
                        />
                        <Select
                            text="Sucursal"
                            classNameParent="col-md-6 mb-2"
                            options={branchOffice.map(p => {
                                return {
                                    label: p.key_branch_office + ' - ' + p.name_branch_office,
                                    value: p.id_branch_office
                                }
                            })}
                            onChange={e => {
                                setReport({})
                                setBranchOfficeSelected(e.value)
                                Controllers.product.get_product({
                                    p_id_branch_office: e.value
                                }).then(res => {
                                    setProducts(res.data)
                                }).catch(req => Helpers.promise.catch({ req, toast }))
                            }}
                        />
                        <Select
                            text="Productos"
                            classNameParent="col-md-6 mb-2"
                            options={products.map(p => {
                                return {
                                    label: p.key_product + ' - ' + p.name_product,
                                    value: p.id_product
                                }
                            })}
                            onChange={e => {
                                setReport({})
                                setProductSelected(e.value)
                            }}
                        />
                    </FormCustom>
                    </div>
                    {!loading && reporte?.filename ? <div className="ui-report-result">
                        <p className="ui-form-section-title">Descarga</p>
                        <a href={reporte?.excel} download={reporte?.filename}>
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div> : <div className="ui-empty-hint">Completa los filtros y genera el reporte.</div>}
                </Card.Body>
            </Card>
        </ReactPlaceholder>
    </div>
}

export default Kardex
